import React, { useEffect, useState } from "react";
import styles from "./institution-owners.module.css";
import { Popconfirm, Typography } from "antd";
import CustomButton from "../../../common/custom-button/custom-button";
import SVGIcon from "../../../constants/SVGIcon";
import CustomTable from "../../../common/custom-table/custom-table";
import { deleteInstitutionOwners, getInstitutionOwners } from "../../../services/institution";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import AddEditOwners from "./components/add-edit-owners/add-edit-owners";

const InstitutionOwners = () => {
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [institutionOwnerList, setInstitutionOwnerList] = useState([]);
  const [editOwnerDetails, setEditOwnerDetails] = useState(null);

  useEffect(() => {
    const timeOut = setTimeout(() => {
      setPageNo(1);
      getInstitutionOwnerList();
    }, 500);
    return () => {
      clearTimeout(timeOut);
    };
  }, []);

  const getInstitutionOwnerList = async (
    tempPage = pageNo,
    tempPageSize = pageSize
  ) => {
    try {
      setLoading(true);
      const payload = {
        page: tempPage,
        pageSize: tempPageSize,
      };

      const response = await getInstitutionOwners(payload);
      if (response?.data) {
        const tempList = response?.data?.data?.owners?.map((e, i) => {
          return {
            index: i + 1,
            ...e,
          };
        });
        setInstitutionOwnerList(tempList);
        setTotalCount(response?.data?.data?.totalRecords);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  const handleDeleteOwners = async (owner_id) => {
    console.log("owner_id",owner_id);
    
    try {
      setLoading(true);
      const response = await deleteInstitutionOwners(owner_id);
      if (response?.status) {
        toast.success("Institution owner Deleted Successfully !");
        getInstitutionOwnerList();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("An error occured, please try again.");
      console.log("error", error);
    }
  };

  const handleChangePage = (page, pageSize) => {
    setPageNo(page);
    setPageSize(pageSize);
    getInstitutionOwnerList(page, pageSize);
  };

  const handleOpenDrawer = () => {
    setOpenDrawer(true);
  };

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
    setEditOwnerDetails(null);
    getInstitutionOwnerList();
  };

  const onUpdateDetails = (record) => {
    setEditOwnerDetails(record);
    setOpenDrawer(true);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (value) => value || "-",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (value) => value || "-",
    },
    {
      title: "Phone No.",
      dataIndex: "phone_number",
      key: "phone_number",
      render: (value) => value || "-",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
      render: (value) => value || "-",
    },
    {
      title: "Website",
      dataIndex: "website",
      key: "website",
      render: (value) => value || "-",
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      render: (value) => dayjs(value).format("MM-DD-YYYY") || "-",
    }
  ];

  const menuItems = (record) => [
    {
      key: "1",
      label: "Update",
      onClick: () => onUpdateDetails(record),
    },
    {
      key: "2",
      label: (
        <Popconfirm
          title={`Are you sure you want to delete the owner?`}
          onConfirm={() => handleDeleteOwners(record?.id)}
          okText="Yes"
          cancelText="No"
        >
          <span>Delete</span>
        </Popconfirm>
      ),
    },
  ];

  return (
    <div className={styles.institutions}>
      <div className={styles.headerContainer}>
        <Typography className={styles.title}>Institution Owners</Typography>
        <div className={styles.filterContainer}>
          <CustomButton
            title="Add New Owners"
            size={"large"}
            icon={
              <SVGIcon
                name={"add-icon"}
                width={"24"}
                height={"24"}
                className="anticon"
                stroke={"#FFF"}
              />
            }
            onClick={handleOpenDrawer}
          />
        </div>
      </div>

      <div className={styles.tableContainer}>
        <CustomTable
          columns={columns}
          dataSource={institutionOwnerList}
          total={totalCount}
          loading={loading}
          showMoreIcon={true}
          menuItems={menuItems}
          pageSize={pageSize}
          currentPage={pageNo}
          handlePageChange={handleChangePage}
        />

        {openDrawer && (
          <AddEditOwners
            open={openDrawer}
            onClose={handleCloseDrawer}
            editOwnerDetails={editOwnerDetails}
          />
        )}
      </div>
    </div>
  )
}

export default InstitutionOwners;